import { render, staticRenderFns } from "./ReactionTest.vue?vue&type=template&id=606d4459&scoped=true"
import script from "./ReactionTest.vue?vue&type=script&lang=js"
export * from "./ReactionTest.vue?vue&type=script&lang=js"
import style0 from "./ReactionTest.vue?vue&type=style&index=0&id=606d4459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606d4459",
  null
  
)

export default component.exports